import React, { useEffect } from 'react'; // eslint-disable-next-line
import { Row, Col, Card, CardBody, CardHeader, Button, Image } from 'react-bootstrap'; // eslint-disable-next-line
import { copiriPortalRequest, getLanguagePackUrl } from '../api/api'; // eslint-disable-next-line
import config from '../../config'; // eslint-disable-next-line
import CopiriLoader from '../common/CopiriLoader';
import no_gl_seal_light from '../../assets/img/logos/no_gl_seal_light.png';
import Footer from './Footer';
const ElectionVotingAboutStart = props => {
	const { pageLanguageContent, votingData } = props;
	useEffect(() => {
		// eslint-disable-next-line
	}, []);
	return (
		<Row className='row mx-0 g-0'>
			{/* Left Side - Blue Card */}
			<Col md={6} className='pl-0'>
				<div className='voting-left d-flex flex-column justify-content-between p-4'>
					<div className='content'>
						<span className='badge-election'>
							<i className='fas fa-check-to-slot'></i>{' '}
							{pageLanguageContent['VOT008'] ? pageLanguageContent['VOT008'] : ''}
						</span>
						<h5 className='mt-4 text-white'>
							<Image
								src={votingData.organization_icon ? votingData.organization_icon : no_gl_seal_light}
								alt={votingData?.organization_name}
							/>{' '}
							{votingData?.organization_name}
						</h5>
						<h2 className='text-white'>{votingData?.title}</h2>
						<p className='text-white mt-3'>{votingData?.description}</p>
					</div>
					<Footer pageLanguageContent={pageLanguageContent} votingData={votingData} />
				</div>
			</Col>

			{/* Right Side - Voting Message */}
			<Col md={6} className='rightSide d-flex align-items-center justify-content-center'>
				<div className='text-center'>
					<div className='clock-icon'>
						<i className='far fa-clock'></i>
					</div>
					<h3>{votingData?.status_text}</h3>
				</div>
			</Col>
		</Row>
	);
};
export default ElectionVotingAboutStart;
